// extracted by mini-css-extract-plugin
module.exports = {"menu1":"RightClick_menu1__A41en","avasagButton2":"RightClick_avasagButton2__2td3v"};